module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(
    _vm.$route.path.indexOf('_detail') === -1 &&
    _vm.$route.path.indexOf('_edit') === -1
  ) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "商品编号",
      "size": "mini"
    },
    model: {
      value: (_vm.params.item_num_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_num_id", $$v)
      },
      expression: "params.item_num_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_num_id",
      "label": "商品编码",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "approval_no",
      "label": "批准文号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "approval_url",
      "label": "批准文号证书文件"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "approval_begin_date",
      "label": "批准文号证书起始日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.approval_begin_date, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 1259442598)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "approval_end_date",
      "label": "批准文号证书截止日期"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.approval_end_date, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 1590573102)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-177dd518", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-177dd518"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/zizhi/itemslist.vue
// module id = 2497
// module chunks = 0